if (!customElements.get('promo-countdown')) {
  let lastRefreshAt = 0;

  customElements.define('promo-countdown', class PromoCountdown extends HTMLElement {
    connectedCallback() {
      this._end = parseInt(this.dataset.end, 10) * 1000;
      this._text = this.querySelector('[data-promo-countdown-text]');
      this._timer = setInterval(() => this.tick(), 1000);
      this.tick();
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    tick() {
      const remaining = this._end - Date.now();
      if (!(remaining > 0)) {
        this.expire();
        return;
      }
      if (!this._text) return;

      const hourMs = 1000 * 60 * 60;
      if (remaining > 24 * hourMs) {
        // Round up so a 72h window reads "3 days" for the whole first day.
        const days = Math.ceil(remaining / (24 * hourMs));
        this._text.textContent = days > 1 ? `${days} days` : `${days} day`;
      } else {
        // Total hours, so exactly 24h reads "24h 0m 0s".
        const hours = Math.floor(remaining / hourMs);
        const minutes = Math.floor((remaining % hourMs) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
        this._text.textContent = `${hours}h ${minutes}m ${seconds}s`;
      }
    }

    expire() {
      clearInterval(this._timer);
      this.hidden = true;
      document.dispatchEvent(new CustomEvent('promo:expired'));
      this.refreshPrice();
    }

    // Asks the server for the price blocks again; the Liquid no longer applies
    // the promo once its window has passed, so the original price comes back.
    refreshPrice() {
      // Stops a refresh loop if the visitor's clock is ahead of the server's.
      if (Date.now() - lastRefreshAt < 30000) return;
      lastRefreshAt = Date.now();

      const info = this.closest('product-info');
      if (!info) {
        this.reloadOnce();
        return;
      }

      const variantId = info.currentVariant?.value;
      const query = variantId ? `variant=${variantId}&` : '';
      fetch(`${info.dataset.url}?${query}section_id=${info.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          ['price-top', 'price'].forEach((prefix) => {
            const id = `${prefix}-${info.dataset.section}`;
            const source = html.getElementById(id);
            const destination = info.querySelector(`#${id}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });
        })
        .catch((error) => console.error(error));
    }

    reloadOnce() {
      try {
        const last = parseInt(sessionStorage.getItem('promoExpiredReload'), 10) || 0;
        if (Date.now() - last < 60000) return;
        sessionStorage.setItem('promoExpiredReload', String(Date.now()));
      } catch (e) {}
      window.location.reload();
    }
  });
}
